export { default } from "./CardLimitBadge";



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/CardLimitBadge/index.js